import React, { Component } from 'react';
import classNames from 'classnames';
import { uniqueId } from 'helpers/uniqueId';

import { OrderItemModel } from 'stores/UserProfile/types';

import style from 'components/OrderItemsList/OrderItemsList.module.scss';

interface Props {
  items: OrderItemModel[];
  styles?: {
    list?: string;
    item?: string;
    childList?: string;
    childItem?: string;
  };
  recent: boolean;
}

class OrderItemsList extends Component<Props> {
  render() {
    const { items, styles, recent } = this.props;

    return (
      <ul
        className={classNames(
          style.items,
          styles?.list,
          recent ? style.recentOrder : '',
        )}
      >
        {items.map?.(item => (
          <li key={uniqueId()}>
            <div className={classNames(style.item, styles?.item)}>
              <span className={style.item__amount}>{item.amount}x</span>
              <span className={style.item__title}>{item.title}</span>
            </div>

            {!!item.children?.length && (
              <ul className={classNames(style.childList, styles?.childList)}>
                {item.children.map(childItem => (
                  <li
                    key={uniqueId()}
                    className={classNames(
                      style.item,
                      styles?.item,
                      style.childItem,
                      styles?.childItem,
                    )}
                  >
                    <span>-</span>
                    <span className={style.item__amount}>
                      {childItem.amount}x
                    </span>
                    <span className={style.item__title}>{childItem.title}</span>
                  </li>
                ))}
              </ul>
            )}
          </li>
        ))}
      </ul>
    );
  }
}

export default OrderItemsList;
